import { useState } from "react";
import { resizedUrl, noteResizeFailure } from "../lib/img";

/**
 * A plain <img> that loads a small resized copy when one is available and
 * quietly falls back to the original if that fails.
 * `width`: the size (in px, ideally 2x the displayed size) to ask for.
 */
export default function SmartImg({ src, width, still = false, alt = "", ...rest }) {
  const [useOriginal, setUseOriginal] = useState(false);
  const resized = useOriginal ? src : resizedUrl(src, width, { still });
  return (
    <img
      src={resized}
      alt={alt}
      loading="lazy"
      decoding="async"
      onError={() => {
        if (resized !== src) {
          noteResizeFailure();
          setUseOriginal(true);
        }
      }}
      {...rest}
    />
  );
}
